module.exports = __webpack_public_path__ + "img/sturm-graz-logo-icon.37b76a6c.png";